import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import styles from './InsuranceBookingConfirmation.module.scss';
import { useAppSelector } from 'redux/reduxHooks';
import { ReactComponent as CheckCircleIcon } from 'assets/icons/check_circle.svg';

import useIsLoadedInsideIframe from 'hooks/useIsLoadedInsideIframe';
import { ReactComponent as ConfirmIcon } from 'assets/icons/confirm.svg';

import InsuranceInputForm from './InsuranceInputForm/InsuranceInputForm';
import InsuranceUploadForm from './InsuranceUploadForm/InsuranceUploadForm';
import { renderToast } from 'components/CustomToast/CustomToast';

const InsuranceBookingConfirmation = () => {
  const {
    bookingFormSlice: {
      step3: { currentInsurance },
    },
    clinicDetailsSlice: {
      clinicData: { isInsuranceRequired },
    },
  } = useAppSelector((state) => state);

  const isLoadedInsideIframe = useIsLoadedInsideIframe();

  const containerClassName = cx({
    [styles['container']]: true,
    [styles['container-iframe']]: isLoadedInsideIframe,
  });

  const headerSectionClassName = cx({
    [styles['headerSection']]: true,
    [styles['headerSection-iframe']]: isLoadedInsideIframe,
  });

  const bodySectionClassName = cx({
    [styles['bodySection']]: true,
    [styles['bodySection-iframe']]: isLoadedInsideIframe,
  });

  const wrapperClassName = cx({
    [styles['wrapper']]: true,
    [styles['wrapper-iframe']]: isLoadedInsideIframe,
  });

  const insuranceSectionClassName = cx({
    [styles['insurance-section']]: true,
    [styles['insurance-section-required']]: isInsuranceRequired,
  });

  const [isUploadMode, setIsUploadMode] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    renderToast({
      type: 'success',
      message:
        'Your booking was successful, you will receive a confirmation email shortly.',
      duration: 30000,
    });
  }, []);

  return (
    <div>
      <div className={wrapperClassName}>
        <ConfirmIcon />
        <div className={styles.title}>Appointment Confirmed!</div>
      </div>
      <div className={containerClassName}>
        <div className={styles['patient-form-container']}>
          <div className={headerSectionClassName}>
            <div className={styles['title']}>
              Enter your Insurance info to expedite your visit?
            </div>
          </div>

          <div className={bodySectionClassName}>
            {!isInsuranceRequired && (
              <span>
                If you do not have this information with you, you can call us
                prior to your visit or present your insurance info at your visit
              </span>
            )}

            <div className={insuranceSectionClassName}>
              <h3>Insurance Carrier: </h3>
              <div>
                <CheckCircleIcon className={styles['check-circle']} />
                <span>
                  {currentInsurance?.name ?? 'Bright Health Insurance'}
                </span>
              </div>
            </div>

            {isUploadMode ? <InsuranceUploadForm /> : <InsuranceInputForm />}

            <div className={styles['toggle-mode']}>
              {isUploadMode ? (
                <section>
                  <span>Don't have your card?</span>{' '}
                  <button onClick={() => setIsUploadMode(false)}>
                    Enter insurance details manually
                  </button>
                </section>
              ) : (
                <button onClick={() => setIsUploadMode(true)}>
                  Upload photos instead
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceBookingConfirmation;
